import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import ShopPage from "@/pages/ShopPage";
import ProductDetail from "@/pages/ProductDetail";
import OrderReviewPage from "@/pages/OrderReviewPage";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import WhatsAppWidget from "@/components/WhatsAppWidget";
import { AuthProvider } from "@/lib/AuthContext";
import { CartProvider } from "@/lib/CartContext";
import { LangProvider } from "@/lib/i18n";

function App() {
  return (
    <div className="App">
      <LangProvider>
        <AuthProvider>
          <CartProvider>
            <BrowserRouter>
              <Routes>
                <Route path="/" element={<ShopPage />} />
                <Route path="/products/:slug" element={<ProductDetail />} />
                <Route path="/review/:token" element={<OrderReviewPage />} />
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route path="/admin/*" element={<AdminDashboard />} />
              </Routes>
            </BrowserRouter>
            <WhatsAppWidget />
            <Toaster position="top-right" richColors closeButton />
          </CartProvider>
        </AuthProvider>
      </LangProvider>
    </div>
  );
}

export default App;
